import { render, staticRenderFns } from "./quizPop.vue?vue&type=template&id=31fe837a"
import script from "./quizPop.vue?vue&type=script&lang=js"
export * from "./quizPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fe837a')) {
      api.createRecord('31fe837a', component.options)
    } else {
      api.reload('31fe837a', component.options)
    }
    module.hot.accept("./quizPop.vue?vue&type=template&id=31fe837a", function () {
      api.rerender('31fe837a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/edu/quizPop.vue"
export default component.exports